import React, { useEffect, useState } from 'react'
import './Timeline.css'
import { useTranslation } from 'react-i18next'
import { GiOffshorePlatform } from 'react-icons/gi'
import { useHistory } from 'react-router-dom'
import { Link } from 'components/common'
import moment from 'moment'

const RunningCard = ({ data }) => {
    const { t } = useTranslation()
    const history = useHistory()
    const [selectDetail, setSelectDetail] = useState('')
    const toGo = (value) => {
        setSelectDetail(value)
    }

    useEffect(() => {
        if (selectDetail === 'running') {
            window.location.href = `https://runningexpert.${process.env.REACT_APP_DOMAIN}/job-details/${data.detail['Job Id']}`
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectDetail, history])

    const content = <>
        <div className="timeline-item-content">
            <span className="title">
                <GiOffshorePlatform className="icon" />
                {t('tlh.ippn.running.title')}
            </span>
            <div>
                <section className="container row">
                    <div className="item">
                        <span className="label">{t('tlh.ippn.running.country')}: </span>
                        <span className="value">{data.detail['Country']}</span>
                    </div>
                    <div className="item">
                        <span className="label">{t('tlh.ippn.running.oilCompany')}: </span>
                        <span className="value">{data.detail['Oil Company']}</span>
                    </div>

                    <div className="item">
                        <span className="label">{t('tlh.ippn.running.Barcode')}: </span>
                        <span className="value">{data.detail['Barcode']}</span>
                    </div>


                </section>
                <section className="container row">

                    <div className="item">
                        <span className="label">{t('tlh.ippn.running.well')}: </span>
                        <Link onClick={() => toGo('running')}>
                            {data.detail['Well']}
                        </Link>
                    </div>
                    <div className="item">
                        <span className="label">{t('tlh.ippn.running.wellSection')}: </span>
                        <span className="value">{data.detail['well Section']}</span>
                    </div>
                </section>
                <section className="container row">

                    <div className="item">
                        <span className="label">{t('tlh.ippn.running.drillingContractor')}: </span>
                        <span className="value">{data.detail['Drilling Contractor']}</span>
                    </div>
                    <div className="item">
                        <span className="label">{t('tlh.ippn.running.tallyNumber')}: </span>
                        <span className="value">{data.detail['Tally Number']}</span>
                    </div>

                </section>
                <section className="container row">

                    <div className="item">
                        <span className="label">{t('tlh.ippn.running.jobType')}: </span>
                        <span className="value">{data.detail['Job Type']}</span>
                    </div>
                    <div className="item">
                        <span className="label">{t('tlh.ippn.running.rigName')}: </span>
                        <span className="value">{data.detail['Rig Name']}</span>
                    </div>
                </section>
                <section className="container row">
                    <div className="item">
                        <span className="label">{t('tlh.ippn.running.status')}: </span>
                        <span className="value">{data.detail['Status']}</span>
                    </div>
                </section>

                <span className="circle" > {moment(data.date).format('DD/MM/YYYY')} </span>
            </div>

        </div>
    </>
    return content
}

export default RunningCard